<template>
  <div class="about" id="nosotros">
    <b-container>
      <b-row align-content="between">
        <b-col md="6" class="d-flex flex-column justify-content-center pr-sm-5">
          <h1 class="display-4 font-weight-bold mb-4 mb-sm-5 color-darken-1">
            Nosotros
          </h1>
          <p class="font-weight-light" v-html="content"></p>
        </b-col>
        <b-col md="5" class="d-flex flex-column mt-3 mt-sm-0">
          <img
            :src="require('@/assets/oficina-estudio9-1.jpg')"
            alt="Oficina de estudio9"
            class="img-fluid smooth-shadow"
          />
          <img
            :src="require('@/assets/oficina-estudio9-2.jpg')"
            alt="Oficina de estudio9"
            class="img-fluid smooth-shadow mt-3 mt-sm-5"
          />
          <img
            :src="require('@/assets/dots.png')"
            alt="Elemento de decoracion"
            class="img-fluid dots"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { db } from "../services/firebase";

export default {
  name: "About",
  data() {
    return {
      content: ""
    };
  },
  async created() {
    await db
      .collection("about")
      .doc("content")
      .get()
      .then((doc) => {
        this.content = doc.data().text;
      });
  }
};
</script>

<style scoped lang="sass">
.about
  margin: 8rem 0
  // overflow: hidden
  .dots
    transform: translate(calc(50% - 15px), 50%)
    position: absolute
    bottom: 0
    right: 0
    width: 100px
    height: 100px
  @media screen and (max-width: 502px)
    text-align: center
    .dots
      transform: translate(calc(50% - 15px), -100%)
</style>
